export const NAV_ITEMS = {
  principal: [
    { to: '/principal/overview', label: 'Overview', icon: 'dashboard' },
    { to: '/principal/students', label: 'Students', icon: 'students' },
    { to: '/principal/teachers', label: 'Teachers', icon: 'teachers' },
    { to: '/principal/attendance', label: 'Attendance', icon: 'calendar' },
    { to: '/principal/devices', label: 'Devices', icon: 'fingerprint' },
    { to: '/display', label: 'Gate Display', icon: 'eye' },
    { to: '/principal/fees', label: 'Fees', icon: 'receipt' },
    { to: '/principal/academics', label: 'Academics', icon: 'book' },
    { to: '/principal/leaves', label: 'Leaves', icon: 'leave' },
    { to: '/principal/notices', label: 'Notices', icon: 'bell' },
    { to: '/principal/chat', label: 'Chat', icon: 'chat' },
    { to: '/principal/events', label: 'Events', icon: 'calendar' }
  ],
  teacher: [
    { to: '/teacher/today', label: 'Today', icon: 'dashboard' },
    { to: '/teacher/attendance', label: 'Attendance', icon: 'calendar' },
    { to: '/teacher/students', label: 'Students', icon: 'students' },
    { to: '/teacher/homework', label: 'Homework', icon: 'book' },
    { to: '/teacher/marks', label: 'Marks', icon: 'chart' },
    { to: '/teacher/leaves', label: 'Leaves', icon: 'leave' },
    { to: '/teacher/notices', label: 'Notices', icon: 'bell' },
    { to: '/teacher/chat', label: 'Chat', icon: 'chat' }
  ],
  student: [
    { to: '/student/home', label: 'Home', icon: 'dashboard' },
    { to: '/student/attendance', label: 'Attendance', icon: 'calendar' },
    { to: '/student/homework', label: 'Homework', icon: 'book' },
    { to: '/student/results', label: 'Results', icon: 'chart' },
    { to: '/student/fees', label: 'Fees', icon: 'receipt' },
    { to: '/student/timetable', label: 'Timetable', icon: 'clock' },
    { to: '/student/notices', label: 'Notices', icon: 'bell' },
    { to: '/student/chat', label: 'Chat', icon: 'chat' }
  ],
  parent: [
    { to: '/parent/home', label: 'Home', icon: 'dashboard' },
    { to: '/parent/attendance', label: 'Attendance', icon: 'calendar' },
    { to: '/parent/fees', label: 'Fees', icon: 'receipt' },
    { to: '/parent/results', label: 'Results', icon: 'chart' },
    { to: '/parent/homework', label: 'Homework', icon: 'book' },
    { to: '/parent/timetable', label: 'Timetable', icon: 'clock' },
    { to: '/parent/notices', label: 'Notices', icon: 'bell' },
    { to: '/parent/chat', label: 'Chat', icon: 'chat' }
  ]
};

export const BOTTOM_TAB_ITEMS = {
  student: [
    { to: '/student/home', label: 'Home', icon: 'dashboard' },
    { to: '/student/attendance', label: 'Attendance', icon: 'calendar' },
    { to: '/student/homework', label: 'Homework', icon: 'book' },
    { to: '/student/results', label: 'Results', icon: 'chart' },
    { to: '#more', label: 'More', icon: 'menu', isMore: true }
  ],
  parent: [
    { to: '/parent/home', label: 'Home', icon: 'dashboard' },
    { to: '/parent/attendance', label: 'Attendance', icon: 'calendar' },
    { to: '/parent/fees', label: 'Fees', icon: 'receipt' },
    { to: '/parent/results', label: 'Results', icon: 'chart' },
    { to: '#more', label: 'More', icon: 'menu', isMore: true }
  ]
};

export const ROUTE_FEATURE_MAP = {
  '/principal/overview': 'dashboards',
  '/principal/students': 'students',
  '/principal/teachers': 'teachers',
  '/principal/attendance': 'attendance_today',
  '/principal/devices': 'devices',
  '/display': 'gate_display',
  '/principal/fees': 'invoices',
  '/principal/academics': 'classes',
  '/principal/leaves': 'leaves',
  '/principal/notices': 'notices',
  '/principal/chat': 'chat',
  '/principal/events': 'events',

  '/teacher/today': 'dashboards',
  '/teacher/attendance': 'attendance_today',
  '/teacher/students': 'students',
  '/teacher/homework': 'homework',
  '/teacher/marks': 'exams_marks',
  '/teacher/leaves': 'leaves',
  '/teacher/notices': 'notices',
  '/teacher/chat': 'chat',

  '/student/home': 'dashboards',
  '/student/attendance': 'attendance_history',
  '/student/homework': 'homework',
  '/student/results': 'results',
  '/student/fees': 'invoices',
  '/student/timetable': 'timetable',
  '/student/notices': 'notices',
  '/student/chat': 'chat',

  '/parent/home': 'dashboards',
  '/parent/attendance': 'attendance_history',
  '/parent/fees': 'invoices',
  '/parent/results': 'results',
  '/parent/homework': 'homework',
  '/parent/timetable': 'timetable',
  '/parent/notices': 'notices',
  '/parent/chat': 'chat'
};

export function isRouteVisible(role, to) {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem('te_admin_v1') : null;
    if (!raw) return true;
    const admin = JSON.parse(raw);
    if (!admin) return true;

    // Check hiddenMenus
    if (admin.hiddenMenus?.[role]?.includes(to)) {
      return false;
    }

    // Check feature flag
    const featId = ROUTE_FEATURE_MAP[to];
    if (featId && admin.features?.[featId]?.enabled === false) {
      return false;
    }
    return true;
  } catch (e) {
    return true;
  }
}

export function getNavItems(role) {
  const items = NAV_ITEMS[role] || [];
  return items.filter((item) => isRouteVisible(role, item.to));
}

export function getBottomTabItems(role) {
  const items = BOTTOM_TAB_ITEMS[role] || [];
  return items.filter((item) => item.isMore || isRouteVisible(role, item.to));
}

export function homeFor(role) {
  switch (role) {
    case 'principal':
      return '/principal/overview';
    case 'teacher':
      return '/teacher/today';
    case 'student':
      return '/student/home';
    case 'parent':
      return '/parent/home';
    default:
      return '/login';
  }
}

